import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {NotificationBaseApiDto} from "../../../api/model/rest";
import JobUserMentionNotificationData from "./JobUserMentionNotificationData";

/**
 * Job user mention notification class.
 */
export default class JobUserMentionNotification extends NotificationBase {
	/**
	 * @param {string} id notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read flag if sms is marked as read.
	 * @param {string} type in this case always 'USER_MENTIONED'.
	 * @param {JobUserMentionNotificationData} data user mention notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: JobUserMentionNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): JobUserMentionNotification {
		return new JobUserMentionNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			JobUserMentionNotificationData.fromJson(json.data as JobUserMentionNotificationData));
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new JobUserMentionNotification(id, dateTime, read, type, data);
	}
}